import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import AnnouncementBar from "@/components/AnnouncementBar";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import EmergencyDock from "@/components/EmergencyDock";
import Home from "@/pages/Home";
import SeoPage from "@/pages/SeoPage";
import Leistungen from "@/pages/Leistungen";
import Einsatzgebiet from "@/pages/Einsatzgebiet";
import UeberUns from "@/pages/UeberUns";
import FaqPage from "@/pages/FaqPage";
import Kontakt from "@/pages/Kontakt";
import { CookieSettings, Datenschutz, Impressum } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import ComingSoon from "@/pages/ComingSoon";
import { useLaunchGate } from "@/lib/launch";
import { SEO_PAGES } from "@/data/seoPages";

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, touchMultiplier: 1.6 });
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const locked = useLaunchGate();

  useEffect(() => {
    document.body.style.paddingTop = locked ? "0px" : "";
  }, [locked]);

  if (locked) {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <SmoothScroll />
      <ScrollToTop />
      <a
        href="#inhalt"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-[calc(var(--banner-h)+8px)] focus:z-[70] focus:rounded-full focus:bg-[#062B52] focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-white"
      >
        Zum Inhalt springen
      </a>
      <AnnouncementBar />
      <Header />
      <div id="inhalt" />
      <Routes>
        <Route path="/" element={<Home />} />
        {SEO_PAGES.map((p) => (
          <Route key={p.slug} path={p.slug} element={<SeoPage />} />
        ))}
        <Route path="/leistungen" element={<Leistungen />} />
        <Route path="/einsatzgebiet" element={<Einsatzgebiet />} />
        <Route path="/ueber-uns" element={<UeberUns />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/cookie-einstellungen" element={<CookieSettings />} />
        <Route
          path="/winterdienst-privat"
          element={<Navigate to="/winterdienst-bremen-privat" replace />}
        />
        <Route
          path="/winterdienst-gewerbe"
          element={<Navigate to="/winterdienst-bremen-gewerbe-hausverwaltung" replace />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <EmergencyDock />
      <MobileBar />
      <div className="h-[60px] lg:hidden" />
    </BrowserRouter>
  );
}

export default App;
